import { RadarLegend } from './RadarLegend';
import type { MapTileProvider } from './useNowcastingState';
import type { TioTileField } from '../../api/tomorrowIoTilesService';

interface LegendCardProps {
  isVisible: boolean;
  mapTileProvider: MapTileProvider;
  tioTileField?: TioTileField;
  isRainOnlyMode: boolean;
  numericColormap?: string;
  compact?: boolean;
  onCompactChange?: (compact: boolean) => void;
  cardPosition: { x: number; y: number } | null;
  isDragging: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
  onClose: () => void;
  cardRef: React.RefObject<HTMLDivElement | null>;
}

export const LegendCard = ({
  isVisible,
  mapTileProvider,
  tioTileField,
  isRainOnlyMode,
  numericColormap,
  compact = false,
  onCompactChange,
  cardPosition,
  isDragging,
  onMouseDown,
  onClose,
  cardRef,
}: LegendCardProps) => {
  if (!isVisible) return null;

  return (
    <div
      ref={cardRef}
      onMouseDown={onMouseDown}
      style={{
        position: 'absolute',
        ...(cardPosition
          ? { left: cardPosition.x, top: cardPosition.y }
          : { top: 100, right: 70 }),
        zIndex: isDragging ? 2000 : 1001,
        cursor: isDragging ? 'grabbing' : 'default',
      }}
    >
      <div className="drag-handle" style={{ cursor: 'grab' }}>
        <RadarLegend
          mapTileProvider={mapTileProvider}
          tioTileField={tioTileField}
          isRainOnlyMode={isRainOnlyMode}
          numericColormap={numericColormap}
          compact={compact}
          onCompactChange={onCompactChange}
          onClose={onClose}
        />
      </div>
    </div>
  );
};
